import Api from './Api'
export default {
    getSettings() {
        return Api().get('getSettings');
    },
    updateSettings(obj) {
        return Api().post('updateSettings', obj);
    },
}